import { render, staticRenderFns } from "./FilterBlock.vue?vue&type=template&id=0af9c362&scoped=true"
import script from "./FilterBlock.vue?vue&type=script&lang=js"
export * from "./FilterBlock.vue?vue&type=script&lang=js"
import style0 from "./FilterBlock.vue?vue&type=style&index=0&id=0af9c362&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af9c362",
  null
  
)

export default component.exports